import { createContext, type ReactNode, useContext, useState } from 'react';

/** owing: anything unpaid; late: a bill past its due date; all: everyone. */
export type ListFilter = 'owing' | 'late' | 'all';

type ListState = {
  search: string;
  setSearch: (search: string) => void;
  filter: ListFilter;
  setFilter: (filter: ListFilter) => void;
};

const Context = createContext<ListState | null>(null);

/** Search and filter kept while moving between the list and a member. */
export function ListStateProvider({ children }: { children: ReactNode }) {
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState<ListFilter>('owing');
  return (
    <Context.Provider value={{ search, setSearch, filter, setFilter }}>
      {children}
    </Context.Provider>
  );
}

export function useListState(): ListState {
  const state = useContext(Context);
  if (!state) throw new Error('useListState outside ListStateProvider');
  return state;
}
